import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useNavigate } from "react-router";

import CustomAvatar from "./../../CustomAvatar/index";
import { Box, Typography } from "@mui/material";

const ProfilePicture = ({ profile }) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        marginTop: "70px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "60px",
      }}
    >
      <CustomAvatar
        link={"/profile/editprofile/profilepicture"}
        size={120}
        src={profile?.avatar}
        alt={profile?.nickname}
      />

      <Box
        style={{
          display: "flex",
          alignItems: "center",
          color: "#1976D2",
        }}
        onClick={() => navigate("/profile/editprofile/profilepicture")}
      >
        <ModeEditOutlineOutlinedIcon
          style={{ width: "16px", height: "16px" }}
        />
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            paddingTop: "4px",
            cursor: "pointer",
            color: "secondary.main",
            pl: "4px",
          }}
        >
          Edit profile picture
        </Typography>
      </Box>
    </div>
  );
};

export default ProfilePicture;
